//import forEach from 'lodash/forEach';
//import {Action} from '../../types';
//import {baseReducer} from '../../lib/base/reducer';
import { BaseController } from "../../lib/base/controller";
export class FeatureSelectionsController extends BaseController {
}
